import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import { IClient, IClientCreatePayload, IClientUpdatePayload } from "../../../types/api/client";

export async function listClient(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IClient[]>>> {
  return axios.get(API_ENDPOINTS.CLIENT_LIST, { params: qData });
}

export async function clientDetail(
  id: string | number
): Promise<AxiosResponse<TResponse<IClient>>> {
  return axios.get(`${API_ENDPOINTS.CLIENT_DETAIL}/${id}`);
}

export async function createClient(
  data: IClientCreatePayload
): Promise<AxiosResponse<TResponse<IClient>>> {
  return axios.post<TResponse<IClient>>(API_ENDPOINTS.CLIENT_CREATE, data);
}

export async function updateClient(
  data: IClientUpdatePayload
): Promise<AxiosResponse<TResponse<IClient>>> {
  return axios.post<TResponse<IClient>>(API_ENDPOINTS.CLIENT_UPDATE, data);
}

export async function deleteClient(
  data: IDeleteDataResponseAndPayload
): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
  return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.CLIENT_DELETE, data);
}

// ── Client Sites ──────────────────────────────────────────────────────────────

export async function listClientSites(clientId: number): Promise<AxiosResponse<TResponse<any[]>>> {
  return axios.get(`${API_ENDPOINTS.CLIENT_SITES}/${clientId}/sites`);
}

export async function createClientSite(clientId: number, data: any): Promise<AxiosResponse<TResponse<any>>> {
  return axios.post(`${API_ENDPOINTS.CLIENT_SITES}/${clientId}/sites`, data);
}

export async function updateClientSite(clientId: number, siteId: number, data: any): Promise<AxiosResponse<TResponse<any>>> {
  return axios.put(`${API_ENDPOINTS.CLIENT_SITES}/${clientId}/sites/${siteId}`, data);
}

export async function deleteClientSite(clientId: number, siteId: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete(`${API_ENDPOINTS.CLIENT_SITES}/${clientId}/sites/${siteId}`);
}
